import React, { memo, useMemo } from 'react';
import { useServerTimeUFO } from '@atlassian/jira-spa-apps-issue-navigator-common/src/index.tsx';
import {
	appBundleReadyMark,
	prefetchApiReadyMark,
} from '@atlassian/jira-providers-spa-apdex-analytics/src/marks.tsx';
import SubmitApdex from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/index.tsx';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';
import { NINPageLoad } from '@atlassian/jira-issue-navigator/src/common/utils/performance-analytics.tsx';

type Attributes = {
	[key: string]: number | string | boolean;
};

export type Props = {
	appName: string;
	attributes?: Attributes;
	emitOnAnimationFrame?: boolean;
	scope: 'project' | 'global';
};

export const IssueNavigatorSubmitApdex = memo(
	({ appName, attributes, emitOnAnimationFrame, scope }: Props) => {
		const getServerTimeUFO = useServerTimeUFO();

		const extra = useMemo(
			() => ({
				scope,
				...getServerTimeUFO?.(),
				...attributes,
			}),
			[attributes, getServerTimeUFO, scope],
		);

		return (
			<>
				{/* @ts-expect-error - Types for JFE BM3Metric and @atlassian/browser-metrics' PageLoadMetric are not compatible */}
				<SubmitApdex
					appName={appName}
					isExpectedToHaveSsr
					withMarks={[appBundleReadyMark, prefetchApiReadyMark]}
					ttrSlo={3000}
					ttiSlo={4000}
					extra={extra}
					metric={NINPageLoad}
					emitOnAnimationFrame={emitOnAnimationFrame}
				/>
				<SpaStatePageReady />
			</>
		);
	},
);
